import { InternalAxiosRequestConfig } from 'axios';
import { api } from '../api/api';

/**
 * Generates a unique cache key for an axios request
 * @param {InternalAxiosRequestConfig<any>} config - The axios request configuration
 * @returns {string} A unique cache key based on URL, authorization, and parameters
 */
export const cacheKey = (config: InternalAxiosRequestConfig<any>) =>
  `${config.url}-${config.headers.Authorization}-${JSON.stringify(config.params || {})}`;

/**
 * Stores data in the cache with an expiration time
 * @param {string} key - The cache key to store data under
 * @param {any} data - The data to cache
 * @param {Map<any, any>} cache - The cache Map object
 * @param {number} ttl - Time to live in milliseconds (default: 30000ms/30s)
 * @returns {void}
 */
export const setCache = (key, data, cache, ttl = process.env.REACT_APP_DEBUG === 'true' ? 30000 : 30000) => {
  // ttl is time to live in ms (default: 5 minutes)
  if (key.includes(api.qna.ask)) {
    return;
  }
  const expiryTime = Date.now() + ttl;
  cache.set(key, { data, expiryTime });
};

/**
 * Retrieves data from the cache if it exists and hasn't expired
 * @param {string} key - The cache key to retrieve data for
 * @param {Map<any, any>} cache - The cache Map object
 * @returns {any|null} The cached data or null if not found or expired
 */
export const getCache = (key: string, cache: Map<any, any>) => {
  const cached = cache.get(key);
  if (!cached) return null;

  // Check if the cache has expired
  if (Date.now() > cached.expiryTime) {
    cache.delete(key);
    return null;
  }

  return cached.data;
};
